import { render, staticRenderFns } from "./ParticipantComponent.vue?vue&type=template&id=67838371&scoped=true&"
import script from "./ParticipantComponent.vue?vue&type=script&lang=js&"
export * from "./ParticipantComponent.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantComponent.vue?vue&type=style&index=0&id=67838371&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67838371",
  null
  
)

export default component.exports